import { memo } from 'react';
import { useRouter } from 'next/router';

import { Box } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';

import { REVIEW_PAGE_SECTIONS } from '../../../../constants/ListingDetailConstants';

import AddAmenitiesFormField from '../../../PostingPath/AddAmenities/AddAmenitiesFormField';
import RecommendationsAlert from '../../../PostingPath/RecommendationsAlert';
import SpinnerContainer from '../../../SpinnerContainer';
import CommunityRoomsAmenities from './CommunityRoomsAmenities';
import OutdoorAreasAmenities from './OutdoorAreasAmenities';
import PropertyServicesAmenities from './PropertyServicesAmenities';
import SecurityAmenities from './SecurityAmenities';
import SportCourtsAmenities from './SportCourtsAmenities';
import ViewsAmenities from './ViewsAmenities';

type Props = {
  onRecsClick: (recommendationType: string) => void;
};

const OtherPropertyFeaturesContent = ({ onRecsClick }: Props) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { isPending: isListingDetailsPending } = useGetListingDetails(listingAlias);

  if (isListingDetailsPending) {
    return <SpinnerContainer />;
  }

  return (
    <>
      <RecommendationsAlert sectionName={REVIEW_PAGE_SECTIONS.OTHER_PROPERTY_FEATURES} onRecsClick={onRecsClick} />
      <Box
        data-testid="OtherPropertyFeaturesContent-Edit"
        css={{ display: 'flex', flexDirection: 'row', gap: '400', flexWrap: 'wrap' }}
      >
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
          <ViewsAmenities />

          <CommunityRoomsAmenities />

          <SecurityAmenities />
        </Box>

        <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
          <PropertyServicesAmenities />
        </Box>

        <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
          <SportCourtsAmenities />

          <OutdoorAreasAmenities />
        </Box>

        <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: '1 0 280px' }}>
          <AddAmenitiesFormField />
        </Box>
      </Box>
    </>
  );
};

export default memo(OtherPropertyFeaturesContent);
